import { Autocomplete, Box, TextField } from '@mui/material';
import { useState, useEffect } from 'react';
import countries from '../common/countries';

export default function CountrySelect(props) {

	const countryList	= props.countries || countries
	const defaultWidth 	= props.width || 300

	const [selectedCountries, setSelectedCountries] = useState([])

	useEffect(() => {
		if (props.value) {
			const valuesArray = Array.isArray(props.value) ? props.value : props.value.split(',')
			setSelectedCountries(valuesArray.map(v => {
				return countryList.find(c => c.code === v.replaceAll('\'',''))
			}))
		}
	}, [props.value])

	const handleCountrySelect = (e, newValue) => {
		setSelectedCountries(newValue)
		if (props.onChange) props.onChange(e, newValue)
	}

	return (
		<Autocomplete
			id="country-selector"
			sx={{ width: defaultWidth }}
			options={countryList}
			limitTags={1}
			multiple
			autoHighlight
			disableCloseOnSelect
			getOptionLabel={(option) => option.label}
			value={selectedCountries}
			onChange={(e, newValue) => handleCountrySelect(e, newValue)}
			renderTags={(e) => e.length +' países selecionados'}
			renderOption={(props, option, {selected}) => (
				<Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
					<img
						loading="lazy"
						width="20"
						src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
						srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
						alt=""
					/>
					{option.label} ({option.code})
				</Box>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Escolha o(s) pais(es)"
					inputProps={{
						...params.inputProps,
						autoComplete: 'new-password',
					}}
				/>
			)}
		/>
	);

}
